import { Tree } from "ant-design-vue"
const { TreeNode,DirectoryTree, ...other } = Tree
const YwTree = {
	...other,
	name: "YwTree",
	TreeNode: {
		...TreeNode,
		name: "YwTreeNode",
	},
  DirectoryTree: {
    ...DirectoryTree,
    name: "YwDirectoryTree",
  },
};
YwTree.install = function (Vue) { 
  Vue.component(YwTree.name, Tree);
  Vue.component(YwTree.TreeNode.name, TreeNode);
  Vue.component(YwTree.DirectoryTree.name, DirectoryTree);
}
export default YwTree